import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
import { Anchor } from '@microsoft/fast-foundation';
export class NavigationDrawerLinkComponent extends ChameleonElementMixin(Anchor) {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'menuitem');
    }
}
__decorate([
    attr({ mode: 'boolean' })
], NavigationDrawerLinkComponent.prototype, "selected", void 0);
